import * as React from 'react';
import { TextField as MtextField, InputAdornment, Icon } from '@material-ui/core';

export class TextField extends React.Component<Props, State> {

    public constructor(props: Props) {
        super(props);

        this.state = { value: props.value }

        this.handleChange = this.handleChange.bind(this);
    }

    public componentWillReceiveProps(props: Props) {
        if (props.value != null) {
            this.setState({ value: props.value });
        }
    }

    private handleChange(event: React.ChangeEvent<HTMLInputElement>) {
        var newValue = event.target.value;
        this.setState({ value: newValue });
        if (this.props.onChange != null) {
            this.props.onChange(newValue);
        }
    }

    public render() {
        return (
            <MtextField
                error={this.props.error != null}
                label={this.props.label}
                type={this.props.type}
                multiline={this.props.multiline}
                value={this.state.value}
                helperText={this.props.error != null ? this.props.error : this.props.desc}
                style={{ width: '100%', marginBottom: '24px' }}
                onChange={this.handleChange}
                InputProps={ this.props.startIcon == null ? {} : {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Icon>{this.props.startIcon}</Icon>
                      </InputAdornment>
                    ),
                  }}
            />
        );
    }

}

export interface Props {

    label: string;
    value?: string;
    desc?: string;
    error?: string;
    multiline?: boolean;
    type?: string;
    onChange?: { (newValue: string): void }
    startIcon?: string;

}

interface State {

    value: string;

}